import CourseReviewMessage from '@components/admin/course/review/CourseReviewMessage';
import LargeGreyButton from '@components/common/button/LargeGreyButton';
import ContentBox from '@components/common/ContentBox';
import PageHeader from '@components/common/PageHeader';
import { DepartmentChairAuthContext } from '@src/authContexts';
import { Department } from '@ypp-portal/models/user/staffData';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

const CurriculumReview: React.FC = () => {
  const history = useHistory();
  const {
    idToken: {
      claims: { department },
    },
  } = useContext(DepartmentChairAuthContext);

  return (
    <div className='w-full h-full overflow-auto font-raleway'>
      <PageHeader text='CURRICULUM REVIEW'></PageHeader>
      <div
        className='grid grid-cols-1 lg:grid-cols-2 lg:grid-rows-1 
      gap-4 grid-flow-row lg:grid-flow-col my-10 sm:mx-14 min-h-2/3'
      >
        <ContentBox className='lg:col-span-1 lg:row-span-full'>
          <div className='w-full h-full'>
            <CourseReviewMessage></CourseReviewMessage>
          </div>
        </ContentBox>
        <ContentBox className='lg:col-start-2 lg:col-span-2 lg:row-span-1'>
          {department === Department.Arts || department === Department.Lifestyle ? (
            <>
              <LargeGreyButton
                text={'Review - ARTS'}
                onClick={() => history.push('/admin/curriculum/review/arts')}
              />
              <LargeGreyButton
                text={'Review - SP. SKILLS & LIFESTYLES'}
                onClick={() =>
                  history.push('/admin/curriculum/review/special-skills-and-lifestyle')
                }
              />
            </>
          ) : null}
          {department === Department.CompSciEng || department === Department.SciMath ? (
            <>
              <LargeGreyButton
                text={'Review - COMP. SCI. & ENGINEERING'}
                onClick={() =>
                  history.push('/admin/curriculum/review/computer-science-and-engineering')
                }
              />
              <LargeGreyButton
                text={'Review - SCIENCE & MATHEMATICS'}
                onClick={() => history.push('/admin/curriculum/review/science-and-math')}
              />
            </>
          ) : null}
          {department === Department.Humanities || department === Department.WorldLang ? (
            <>
              <LargeGreyButton
                text={'Review - HUMAN & SOC. SCIENCES'}
                onClick={() =>
                  history.push('/admin/curriculum/review/humanities-and-social-sciences')
                }
              />

              <LargeGreyButton
                text={'Review - WORLD LANGUAGES'}
                onClick={() => history.push('/admin/curriculum/review/world-languages')}
              />
            </>
          ) : null}
        </ContentBox>
      </div>
    </div>
  );
};

export default CurriculumReview;
